import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24'
}, [
  h('path', {
    d: 'M19.5 24H.5c-.3 0-.5-.2-.5-.5v-21c0-.3.2-.5.5-.5H13c.3 0 .5.2.5.5s-.2.5-.5.5H1v20h18V13c0-.3.2-.5.5-.5s.5.2.5.5v10.5c0 .3-.2.5-.5.5z'
  }),
  h('path', {
    d: 'M7.6 17.4c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l9.1-9.1c.2-.2.5-.2.7 0s.2.5 0 .7l-9 9c-.1.1-.2.2-.4.2z'
  }),
  h('path', {
    d: 'M13.3 14.2c-.9 0-1.7-.3-2.2-.8-1.3-1.3-1.6-2.9-1-4.8.9-2.5 3.4-4.9 4.3-5 .1 0 .3 0 .4.1.1.1.2.2.2.4v1.7c1.2-.6 1.8-3 1.8-3.1 0-.2.1-.3.3-.4C20.1 1 23.3.5 23.4.5c.2 0 .3 0 .4.2.2.1.2.3.2.4-.1.3-1.5 6.6-4.9 9.9-2.3 2.3-4.3 3.2-5.8 3.2zm.7-9.3c-.9.7-2.5 2.4-3 4.2-.4 1.4-.1 2.5.8 3.5 1 1 3.5.8 6.6-2.3 2.5-2.5 3.9-7 4.4-8.7-1.1.2-3.1.7-5.1 1.5-.2.9-1.1 3.7-3.2 3.7-.3 0-.5-.2-.5-.5V4.9z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-entries.es6.js